export const columns = [
  {
    key: "count",
    header: "S.",
    isSortable: false,
    className: "count",
  },
  {
    key: "name",
    header: "Order Status Name",
    isSortable: true,
    className: "dark",
  },
  {
    key: "onwardStatusName",
    header: "Onward Order Status Name",
    isSortable: true,
    className: "dark",
  },
  // {
  //   key: "description",
  //   header: "Description",
  //   isSortable: true,
  //   className: "dark",
  // },
];

export type OrderStatusData = {
  id?: string;
  name: string;
  onwardStatusName: string;
};

export type AddEditOrderStatusModalProps = {
  isEdit: boolean;
  isOpen: boolean;
  onClose: () => void;
  initialData?: OrderStatusData | null;
  onSuccess?: () => void;
};
